import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Button } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";

const CreditAssessmentEsign = ({
  setNext,
  setBack,
  loanApplicationId,
  classes,
  isEsign,
  esingDisable,
  setEsignDisable,
  closeModal,
  initiatorType,
  featureFlags,
  loanType,
  prePledgeLoan,
  editable,
}) => {
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");

  const [preview, setPreView] = useState("");
  const [esignLetterState, setEsignLetterState] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [message, setMessage] = useState("");

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
    if (isEsign && !esingDisable) {
      const interval = setInterval(async () => {
        const res = await apiHandler({
          url: endpoint.CREDIT_ASSESSMENT_INITIATE + loanApplicationId,
          method: "GET",
          authToken: authToken,
        });

        setCallInProgress(false);

        if (res?.data?.status === "DONE" && res?.data?.fileLink) {
          setPreView(res?.data?.fileLink);
          clearInterval(interval);
          setEsignDisable(false);
        } else if (res?.data?.status === "REJECTED") {
          setMessage("Your Credit Assessment Letter is Rejected. Please Esign Again");
          setEsignDisable(false);
        }
      }, 10000);

      return () => {
        clearInterval(interval);
      };
    } else {
      GetSanctionLetter();
    }
  }, []);

  const handleNext = () => {
    if (message) {
      toastUpdate(
        "Error",
        "Credit Assessment Letter has rejected. Please Esign again",
        true
      );
    } else if (!preview) {
      toastUpdate(
        "Error",
        "Please Esign or Upload the Cedit Assessment Letter",
        true
      );
    } else {
      setNext();
    }
  };

  const handleBack = () => {
    setBack();
  };

  const GetEsignSanctionLetter = async () => {
    if (!esignLetterState) {
      const interval = setInterval(async () => {
        const res = await apiHandler({
          url: endpoint.CREDIT_ASSESSMENT_INITIATE + loanApplicationId,
          method: "GET",
          authToken: authToken,
        });

        setCallInProgress(false);

        if (res?.data?.status === "DONE" && res?.data?.fileLink) {
          setPreView(res?.data?.fileLink);
          clearInterval(interval);
          setEsignLetterState(true);
        } else if (res?.data?.status === "REJECTED") {
          setMessage("Your Credit Assessment Letter is Rejected. Please Esign Again");
          setEsignLetterState(true);
        }
      }, 10000);

      return () => {
        clearInterval(interval);
      };
    }
  };

  const GetSanctionLetter = async () => {
    setCallInProgress(true);

    const res = await apiHandler({
      url: endpoint.FIND_DOUMENTS + loanApplicationId,
      method: "GET",
      authToken: authToken,
    });

    setCallInProgress(false);

    if (res?.data?.creditAssessLink) {
      setPreView(res?.data?.creditAssessLink);
    } else {
      GetEsignSanctionLetter();
    }
  };

  return (
    <div>
      <GridContainer>
        <GridItem
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ textAlign: "start" }}
        >
          <SubHeader
            label="Credit Assessment Esign"
            subLabel={`Loan Application ID ${loanApplicationId}`}
            onlyLabel
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          {preview ? (
            <iframe src={preview} width="100%" height="500px" />
          ) : (
            <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{
                textAlign: "center",
                marginTop: 50,
              }}
            >
              {message ? (
                { message }
              ) : (
                <>
                  <h4>Document Send for signing. Please authorize.</h4>
                  <br />
                  <CircularProgresss />
                  <br />
                  <h6>Do Not refresh this screen.</h6>
                </>
              )}
            </GridItem>
          )}
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ textAlign: "end" }}
        >
          <Button
            size="small"
            className={classes.nextButton1}
            disabled={callInProgress}
            onClick={() => handleBack()}
          >
            Back
          </Button>

          <Button
            size="small"
            className={classes.nextButton}
            disabled={
              callInProgress ||
              initiatorType === "CUSTOMER" ||
              !preview
            }
            onClick={() => handleNext()}
          >
            Next
          </Button>
        </GridItem>
      </GridContainer>

      {callInProgress && (
        <CircularProgresss callInProgress={callInProgress} />
      )}

      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </div>
  );
};

CreditAssessmentEsign.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  closeModal: PropTypes.func,
};

export default CreditAssessmentEsign;